import React from 'react'
import { ToastContainer } from 'react-toastify'
import { Row, Col } from 'react-bootstrap'
import { INTERVALO_CORTO } from '../../../config/settings'

function DetalleListadoRepresentantesDialog (props) {
  const { detalle } = props

  return (
    <div className='dialog-container'>
      <Row>
        <Col md={6}><h6>Cereal: <b>{detalle.nombreCereal}</b></h6></Col>
        <Col md={6}><h6>Variedad: <b>{detalle.cerealVariedad}</b></h6></Col>
      </Row>
      <Row>
        <Col md={6}><h6>Fecha/Hora de Calado: <b>{detalle.fechaDeCalado}</b></h6></Col>
        <Col md={6}> <h6>Fecha de Cupo: <b>{detalle.fechaCupo}</b></h6></Col>
      </Row>
      <h6>Fecha de Partida: <b>{detalle.fechaDePartida}</b></h6>
      <h6>Fecha/Hora de Vencimiento: <b>{detalle.fechaDeVencimiento}</b></h6>
      <Row>
        <Col md={6}><h6>Tipo de Cupo: <b>{detalle.tipoCupo}</b></h6></Col>
        <Col md={6}><h6>Codigo de Cupo: <b>{detalle.codigoCupo}</b></h6></Col>
      </Row>
      <h6>Exportador: <b>{detalle.razonSocialExportador}</b></h6>
      <h6>Titular CPE: <b>{detalle.titularCp}</b></h6>
      <h6>Remitente Comercial Productor: <b>{detalle.razonSocialRemitenteComercialProductor}</b></h6>
      <h6>Remitente Comercial Venta Primaria: <b>{detalle.razonSocialRemitenteComercialVentaPrimaria}</b></h6>
      <h6>Remitente Comercial Venta Secundaria: <b>{detalle.razonSocialRemitenteComercialVentaSecundaria}</b></h6>
      <h6>Remitente Comercial Venta Secundaria 2: <b>{detalle.razonSocialRemitenteComercialVentaSecundaria2}</b></h6>
      <h6>Corredor Venta Primaria: <b>{detalle.razonSocialCorredorVentaPrimaria}</b></h6>
      <h6>Corredor Venta Secundaria: <b>{detalle.razonSocialCorredorVentaSecundaria}</b></h6>
      <h6>Entregador: <b>{detalle.razonSocialVendedor}</b></h6>
      <h6>Transportista: <b>{detalle.razonSocialTransportista}</b></h6>
      <h6>Chofer: <b>{detalle.razonSocialChofer}</b></h6>
      <Row>
        <Col md={6}><h6>Camión: <b>{detalle.camion}</b></h6></Col>
        <Col md={6}><h6>Acoplado: <b>{detalle.acoplado}</b> </h6></Col>
      </Row>
      <h6>Peso Bruto: <b>{detalle.pesoBruto}</b>  |  Peso Tara: <b>{detalle.pesoTara}</b>  |   Peso Neto: <b>{detalle.pesoNeto}</b></h6>
      <h6>Cosecha: <b>{detalle.cosecha}</b></h6>
      <Row>
        <Col md={6}><h6>Estado proceso: <b>{detalle.estado}</b></h6></Col>
        <Col md={6}> <h6>Humedad: <b>{detalle.humedad}</b></h6></Col>
      </Row>

      {detalle.estadoAutorizacion && <h6>Estado autorización: <b>{detalle.estadoAutorizacion}</b></h6> }
      {detalle.calificacion && <h6>Calificación cereal: <b>{detalle.calificacion}</b></h6> }
      {detalle.calificacionDos && <h6>Calificación cereal 2: <b>{detalle.calificacionDos}</b></h6> }
      <ToastContainer autoClose={INTERVALO_CORTO} />
    </div>
  )
}

export default DetalleListadoRepresentantesDialog
